// extracted by mini-css-extract-plugin
module.exports = {"root":"Blog-module--root--3kv6j","banner":"Blog-module--banner--3CHo8"};